import React from "react";
import { Outlet } from "react-router";
import "./commonLayout.css";

function CommonLayout() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}

export default CommonLayout;
